export const CARD_SECTION_ATTACHMENTS = 'Attachments';

export const CARD_MAX_PINNED_ATTACHMENTS_IMAGES = 16;
export const SNACKBAR_ID_CARD_ATTACHMENTS_IMAGES_LIMIT = 'SNACKBAR_ID_CARD_ATTACHMENTS_IMAGES_LIMIT';
